module.exports = __webpack_public_path__ + "res/24-img_info_t.c298db73b2ec70fe76afe79070a8da6a.png";